export {default} from './persona.vue'